import { FC, useState } from 'react';
import { useUserKeyLookupQuery } from '../hooks/useUserKeyLookupQuery';

import { LookupRequest } from '../types';
import { UserKeyLookupQueryContext } from './UserKeyLookupQueryContext';

/**
 * A context provider that holds the Contact Lookup page's query state
 */
export const UserKeyLookupQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [query, lookup] = useState<LookupRequest>();
  const { isError, isLoading, userKey } = useUserKeyLookupQuery(query);

  return (
    <UserKeyLookupQueryContext.Provider value={{ isLoading, isError, query, lookup, userKey }}>
      {children}
    </UserKeyLookupQueryContext.Provider>
  );
};
